module.exports = __webpack_public_path__ + "static/mtb-p-2-b0aa41ac74fba89e1a451fbb963ebee3.png";